import React, { useEffect } from 'react';
import s from './app.module.scss';

function ViewportSizes () {
	function setupViewportHandler () {
		const viewport = window.visualViewport;
		const layoutViewport = document.querySelector('.layoutViewport');

		// https://developer.mozilla.org/en-US/docs/Web/API/VisualViewport
		function viewportHandler () {
			// if (!layoutViewport) return;
			// Since the bar is position: fixed we need to offset it by the visual
			// viewport's offset from the layout viewport origin.
			const { offsetLeft } = viewport;
			const offsetTop = viewport.height -
        layoutViewport.getBoundingClientRect().height +
        viewport.offsetTop;

			// You could also do this by setting style.left and style.top if you
			// use width: 100% instead.
			document.documentElement.style.setProperty('--offsetTop', offsetTop);
			document.documentElement.style.setProperty('--offsetLeft', offsetLeft);
			document.documentElement.style.setProperty('--viewPortScale', viewport.scale);
			document.documentElement.style.setProperty('--viewportOffsetTop', viewport.offsetTop);
		}

		window.visualViewport.addEventListener('scroll', viewportHandler);
		window.visualViewport.addEventListener('resize', viewportHandler);
	}

	useEffect(() => {
		setupViewportHandler();
	}, []);

	return (
		<div className={`${s.layoutViewport} layoutViewport`} />
	);
}

export default ViewportSizes;
